import React, { Component } from 'react';

import Uuid from '../../../../../support/Uuid';
import CartaPorteMercanciaDocumentacionAduaneraForm from './CartaPorteMercanciaDocumentacionAduaneraForm';
import CartaPorteMercanciaDocumentacionAduaneraList from './CartaPorteMercanciaDocumentacionAduaneraList';

class CartaPorteMercanciaDocumentacionAduaneraManager extends Component {
  state = {}

  handleOnAdd = (data) => {
    const { DocumentacionAduanera = [] } = this.props.data;

    const newData = DocumentacionAduanera.concat([{
      id: Uuid.v4(),
      ...data
    }]);

    this.handleOnListChange(newData);
  }

  handleOnListChange = (data) => {
    const newData = {
      DocumentacionAduanera: data
    }

    this.props.onChange(newData);
  }

  handleOnEdit = (item) => {
    this.setState({
      data: { ...item }
    }, () => {
      this.setState({
        data: undefined
      });
    });
  }

  render() {
    const { data } = this.state;
    const { DocumentacionAduanera =  [] } = this.props.data;

    return (
      <>
        <fieldset>
          <legend>Documentación Aduanera</legend>

          <CartaPorteMercanciaDocumentacionAduaneraForm
            data={ data }
            onAdd={ this.handleOnAdd }
          />

          <CartaPorteMercanciaDocumentacionAduaneraList
            data={ DocumentacionAduanera }
            onEdit={ this.handleOnEdit }
            onChange={ this.handleOnListChange }
          />
        </fieldset>
      </>
    )
  }
}

export default CartaPorteMercanciaDocumentacionAduaneraManager;